<template>
  <!-- Table Container Card -->
  <b-card
    no-body
  >

    <div class="m-2">

      <!-- Table Top -->
      <b-row>

        <!-- Per Page -->
        <b-col
          cols="12"
          md="6"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <TableEntries
            v-model="perPage"
            :options="perPageOptions"
          />
          <Button
            v-if="getUserPermission('CREATE_BUSINESS_AUTOMATION')"
            :label="$t('Add')"
            size="md"
            @click="showModal('modal-lg')"
          />
        </b-col>

        <!-- Search -->
        <b-col
          cols="12"
          md="6"
        >
          <div class="d-flex align-items-center justify-content-lg-end">
            <Button
              :label="$t('Filter')"
              size="md"
              icon="FilterIcon"
              show-icon
              class="mr-1"
              @click="showModal('modal-filter')"
            />
            <Button
              :label="$t('Reset Filter')"
              size="md"
              icon="RotateCwIcon"
              show-icon
              @click="resetFilter"
            />
          </div>
        </b-col>
      </b-row>

    </div>

    <b-table
      ref="nterBranchAccountAccountRef"
      :busy="isBusy"
      :items="chequeClearingAccountList"
      responsive
      :fields="translatedTableHeaders"
      primary-key="id"
      show-empty
      :empty-text="$t('No records available')"
      class="position-relative"
    >

      <template #table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner
            class="align-middle"
            variant="primary"
          />
        </div>
      </template>
      <template #cell(SN)="data">
        {{ getOverallIndex(data.index) }}
      </template>

      <!-- Column: Actions -->
      <template #cell(actions)="data">

        <div class="text-nowrap">
          <!-- Dropdown -->
          <b-dropdown
            variant="link"
            toggle-class="p-0"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >
            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>
            <b-dropdown-item
              v-if="getUserPermission('MODIFY_BUSINESS_AUTOMATION')"
              @click="onSelectChequeClearingAccount(data.item, $event.target, 'edit')"
            >
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50"> {{ $t('Modify') }} </span>
            </b-dropdown-item>

            <b-dropdown-item @click="onSelectChequeClearingAccount(data.item, $event.target, 'view')">
              <feather-icon icon="EyeIcon" />
              <span class="align-middle ml-50"> {{ $t('View') }} </span>
            </b-dropdown-item>
            <b-dropdown-item @click="onDeleteChequeClearingAccount(data.item, $event.target)">
              <feather-icon icon="TrashIcon" />
              <span class="align-middle ml-50"> {{ $t('Delete') }} </span>
            </b-dropdown-item>
          </b-dropdown>
        </div>
      </template>

    </b-table>

    <!-- Pagination -->
    <TablePagination
      v-model="currentPage"
      :from="from"
      :to="to"
      :total-rows="totalEntries"
      :per-page="perPage"
    />

    <!-- modal -->
    <b-modal
      id="modal-lg"
      ref="my-modal"
      no-close-on-backdrop
      :ok-title="buttonLabel"
      :cancel-title="$t('Cancel')"
      cancel-variant="outline-secondary"
      centered
      :ok-disabled="isLoading"
      size="md"
      :title="modalTitle"
      @hidden="resetModal"
      @ok="handleSubmit"
    >
      <validation-observer ref="chequeClearingAccountRules">
        <b-form @submit.prevent="handleSubmit">
          <b-row class="match-height">
            <!-- Claearing Bank Name -->
            <b-col md="12">
              <SelectField
                id="clearing-bank-name"
                v-model="chequeClearingAccountFormData.clearingBankCode"
                :label="$t('Clearing Bank Name')"
                :options="bankOptions"
                :reduce="option => option.value"
                :error-name="$t('Clearing Bank Name')"
                rules="required"
                item="label"
                :placeholder="$t('Select')"
                :readonly="isReadonly"
                :loading="isLoadingBanks"
              />
            </b-col>
            <!-- Claearing Bank Name -->

            <!-- Clearing Bank Mirror Account -->
            <b-col md="12">
              <SelectField
                id="mirrow-account"
                v-model="chequeClearingAccountFormData.accountNumber"
                :label="$t('Clearing Bank Mirror Account')"
                :options="clearingMirrowAccountOptions"
                :reduce="option => option.value"
                :error-name="$t('Clearing Bank Mirror Account')"
                rules="required"
                item="label"
                :placeholder="$t('Select')"
                :readonly="isReadonly"
              />
            </b-col>
            <!-- Clearing Bank Mirror Account -->
          </b-row>

        </b-form>
      </validation-observer>
      <template
        v-if="isReadonly"
        #modal-footer="{ }"
      >
        <div />
      </template>
    </b-modal>
    <!-- modal -->

    <!-- Filter modal -->
    <b-modal
      id="modal-filter"
      ref="my-modal"
      :ok-title="$t('Apply')"
      no-close-on-backdrop
      :cancel-title="$t('Cancel')"
      cancel-variant="outline-secondary"
      centered
      size="md"
      :title="$t('Filters')"
      modal-footer
      @ok="fetchChequeClearingAccount"
      @cancel="resetFilters"
    >
      <b-row class="match-height">
        <!-- Claearing Bank Name -->
        <b-col md="12">
          <SelectField
            id="claearing-bank-name"
            v-model="filter.clearingBankCode"
            :label="$t('Claearing Bank Name')"
            :options="bankOptions"
            :reduce="option => option.value"
            item="label"
            :placeholder="$t('Select')"
            :readonly="isReadonly"
            :loading="isLoadingBanks"
          />
        </b-col>
        <!-- Claearing Bank Name -->

        <!-- Clearing Bank Mirror Account -->
        <b-col md="12">
          <SelectField
            id="mirrow-account"
            v-model="filter.accountNumber"
            :label="$t('Clearing Bank Mirror Account')"
            :options="clearingMirrowAccountOptions"
            :reduce="option => option.value"
            item="label"
            :placeholder="$t('Select')"
            :readonly="isReadonly"
          />
        </b-col>
        <!-- Clearing Bank Mirror Account -->
      </b-row>
    </b-modal>
    <!-- Filter modal -->

    <FullScreenSpinner :show="showSpinner" />
  </b-card>

</template>

<script>
import {
  BCard, BRow, BCol, BTable, BModal, BSpinner,
  BForm, BDropdown, BDropdownItem,
} from 'bootstrap-vue'
import { ValidationObserver } from 'vee-validate'
import { mapActions, mapGetters } from 'vuex'
import { required } from '@validations'
import { modalMixins } from '@core/mixins/modal'
import { tableMixins } from '@core/mixins/table'
import { sweetAlert } from '@core/mixins/sweetAlert'
import { permissionMixin } from '@core/mixins/permission'
import { toAmount } from '@/helpers/formatAmount'
import TablePagination from '@/views/components/table/TablePagination.vue'
import TableEntries from '@/views/components/table/TableEntries.vue'
import FullScreenSpinner from '@/views/components/spinner/FullScreenSpinner.vue'
import Button from '../../../components/button/Button.vue'
import SelectField from '../../../forms/SelectField.vue'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    TablePagination,
    TableEntries,
    Button,
    BTable,
    BSpinner,
    BModal,
    BForm,
    BDropdown,
    BDropdownItem,
    ValidationObserver,
    SelectField,
    FullScreenSpinner,
  },
  mixins: [modalMixins, tableMixins, sweetAlert, permissionMixin],
  data() {
    return {
      isBusy: true,
      buttonLabel: this.$t('Save'),
      modalTitle: this.$t('Create Cheque Clearing Account'),
      isReadonly: false,
      required,
      isRequired: false,
      isLoadingBanks: false,
      isLoading: false,
      sortDesc: false,
      showSpinner: false,
      toAmount,
      tableHeaders: [
        { key: 'SN', label: 'S/N' },
        { key: 'accountName', sortable: true, label: 'Account Name' },
        { key: 'accountNumber', sortable: true, label: 'Account Number' },
        { key: 'clearingBankName', sortable: true, label: 'Clearing Bank Name' },
        { key: 'actions', label: 'Actions' },
      ],
      chequeClearingAccountFormData: {
        clearingBankCode: '',
        accountNumber: '',
      },
      chequeClearingAccountList: [],
      clearingMirrowAccountOptions: [],
      filter: {
        clearingBankCode: '',
        accountNumber: '',
      },
      // bankOptions: [],
    }
  },
  computed: {
    ...mapGetters({
      bankOptions: 'operations/bankOptions',
    }),
    translatedTableHeaders() {
      return this.tableHeaders.map(header => ({ ...header, label: header.label ? this.$t(header.label) : header.key }))
    },
  },
  mounted() {
    this.getAccounts()
    this.fetchChequeClearingAccount()
    // this.fetchBanks()
  },
  methods: {
    ...mapActions({
      getChequeClearingAccountList: 'operations/getChequeClearingAccountList',
      createChequeClearingAccount: 'operations/createChequeClearingAccountAction',
      updateChequeClearingAccount: 'operations/updateChequeClearingAccountAction',
      deleteBusinessAutomation: 'operations/deleteBusinessAutomation',
      getAccountCategoryByCode: 'account/getAccountCategoryByCode',
      getBanks: 'operations/getBanks',
    }),

    onSelectChequeClearingAccount(items, activity, val) {
      this.isReadonly = val === 'edit' ? this.isReadonly = false : this.isReadonly = true
      this.modalTitle = val === 'edit' ? this.$t('Edit Cheque Clearing Account') : this.$t('Cheque Clearing Account')
      this.chequeClearingAccountFormDsata = { ...items }
      this.buttonLabel = this.$t('Update')
      this.$root.$emit('bv::show::modal', 'modal-lg')
    },

    async chequeClearingAccountAction() {
      try {
        this.isLoading = true
        const response = this.buttonLabel === 'Save'
          ? await this.createChequeClearingAccount(this.chequeClearingAccountFormData)
          : await this.updateChequeClearingAccount(this.chequeClearingAccountFormData)
        const { status } = response
        if (status === 200) {
          this.fetchChequeClearingAccount()
          this.hideModal('modal-lg')
          this.alertSuccess({ text: this.$t('Cheque clearing account created successfully') })
        }
      } catch (error) {
        this.handleError(error)
      } finally {
        this.isLoading = false
      }
    },
    handleSubmit(bvModalEvt) {
      bvModalEvt.preventDefault()
      this.$refs.chequeClearingAccountRules.validate().then(success => {
        if (success) {
          const areYouSure = this.$t('Are you sure you want to')
          const thisInterText = this.$t('this Inter-branch transaction account Account?')
          this.confirm(this.chequeClearingAccountAction, { text: `${areYouSure} ${this.buttonLabel} ${thisInterText}` })
        }
      })
    },

    async fetchChequeClearingAccount() {
      try {
        this.isBusy = true
        const response = await this.getChequeClearingAccountList({
          search: this.filter,
          page: this.currentPage,
          limit: this.perPage,
          permission: 'VIEW_BUSINESS_AUTOMATION',
        })
        const { data, status } = response
        if (status === 200 && data.data) {
          this.isBusy = false
          this.chequeClearingAccountList = data.data
          this.totalCount = data.recordCount
        } else {
          this.chequeClearingAccountList = []
        }
      } catch (error) {
        this.alertError({ text: error })
      } finally {
        this.isBusy = false
      }
    },
    // async fetchBanks() {
    //   try {
    //     this.isLoadingBanks = true
    //     const response = await this.getBanks()
    //     const { data, status } = response
    //     if (status === 200 && data.data) {
    //       // eslint-disable-next-line no-nested-ternary
    //       this.bankOptions = data.data.map(item => ({ label: item.name, value: item.code })).sort((a, b) => (a.label === b.label ? 0 : a.label < b.label ? -1 : 1))
    //     } else {
    //       this.bankOptions = []
    //     }
    //   } catch (error) {
    //     this.alertError({ text: error })
    //   } finally {
    //     this.isLoadingBanks = false
    //   }
    // },
    async getAccounts() {
      try {
        const response = await this.getAccountCategoryByCode(10204000)
        const { data, status } = response
        if (status === 200 && data.data) {
          this.clearingMirrowAccountOptions = data.data.filter(item => item.status === 'Active').map(item => ({
            label: item.name,
            value: item.code.toString(),
          }))
        }
      } catch (error) {
        this.alertError({ text: error })
      }
    },
    async onDeleteChequeClearingAccount(item) {
      const deleteChequeClearingAccount = async () => {
        try {
          this.showSpinner = true
          const response = await this.deleteBusinessAutomation({ routeName: 'ChequeClearingAccount', id: item.id })
          const { status } = response
          if (status === 200) {
            this.fetchChequeClearingAccount()
            this.alertSuccess({ text: this.$t('Deleted successfully') })
          }
        } catch (error) {
          this.alertError({ text: error })
        } finally {
          this.showSpinner = false
        }
      }
      this.confirm(deleteChequeClearingAccount, { text: this.$t('Are you sure you want to delete this Cheque Clearing Account?') })
    },
    resetModal() {
      this.chequeClearingAccountFormData = { ...null }
      this.isLoading = false
    },
    resetFilters() {
      this.filter = { ...null }
    },
    resetFilter() {
      this.filter = { ...null }
      this.fetchChequeClearingAccount()
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
